const {
  REACT_APP_ASSETS_PATHS
} = process.env


export type PresentationResponseType = {
  PID: number
  title: string
  subtitle: string
  summary: string
  speaker: string

  pdf_url: string
  ppt_url: string
  pptx_url: string

  thumbnail: number // boolean
  filter_noise: number // boolean
  audio_combined: number // boolean
  audio_duraton: number
  time_skew: number

  ias_usa: number // boolean
  status: number

  podcast: number // boolean

  youtube_id: number
  youtube_published: number // boolean

  published: number // boolean
  number: number

  MID: number
  SMID: number
  rev: number

  created: string
  updated: string
  site_code: string
  slides: SlideResponseType[]
}

export type SlideResponseType = {
  id: number
  presentationID: number
  PID?: number
  status: number
  caption: number // boolean
  audio: number // boolean
  time: number // boolean
  timeRelative: number // boolean
  number: number // boolean
  fileName: string
  createdAt: string
  updatedAt: string
}

export type SlideType = {
  index: number
  imgSrc?: string
  imgSrcThumb?: string
  id?: string | number
  size?: 'orig' | 'thumb'
  fileName?: string
}

export type PresentationType = {
  slides: SlideType[],
  pdfURL: string,
  pptxURL: string,
  pptURL: string
}

export const normalizePresentation = 
  async (p: PresentationResponseType, site: string, args?: Object) => {
    const paths = JSON.parse(REACT_APP_ASSETS_PATHS);
    const path = paths[site];
    const baseURL = `${path}/${p?.PID}`;

    return {
      slides: await normalizeSlides(p?.slides),
      pdfURL: p?.pdf_url ? `${baseURL}/${p?.pdf_url}` : '',
      pptxURL: p?.pptx_url ? `${baseURL}/pptx/${p?.pptx_url}` : '',
      pptURL: p?.ppt_url ? `${baseURL}/ppt/${p?.ppt_url}` : ''
    } as PresentationType
}

export const normalizeSlide = async (
  s: SlideResponseType,
  index: number
): Promise<SlideType> => {
  // const imgSrc = `${REACT_APP_ASSETS_PATH}/${s.PID}/orig/${s.url}`
  // const imgSrc = `${REACT_APP_ASSETS_PATH}/${s.fileName}`
  return {
    imgSrc: s.imgSrc,
    imgSrcThumb: s.imgSrc.replace('/HQ/', '/thumb/'),
    index
  } as SlideType
}

export const normalizeSlides = async (
  slides: SlideResponseType[]
): Promise<SlideType[]> => Promise.all(slides?.map(normalizeSlide))
